import {Injectable} from '@angular/core';
import {AuthState} from '../modules/akita-mimic/models/store-states/auth-state.model';
import {StoreService} from '../modules/akita-mimic/services/store.service';


@Injectable({ providedIn: 'root' })
export class AuthStore extends StoreService<AuthState> {

    public constructor() {
        super('auth', {
            token: '',
            userId: '',
            tokenExpiresTs: 0,
            username: '',
            password: '',
            isLoggedIn: false,
            rememberUser: false,
            fullName: '',
            organisationId: ''
        });
    }
}
